<!-- 📁 src/components/CompetitionHeader.vue -->
<template>
  <div v-if="competition" class="competition-header mb-2">
    <div class="competition-image-shell">
      <img :src="competition.competitions_info?.img_path || defaultImage"
           alt="Competition Image"
           class="competition-image">
      <template v-if="competition.publish_at && !competition.started_at">
        <CountDown
            :competition_date="competition.competitions_info?.date_start || null"
            :competition_timezone="competition.competitions_info?.country_timezone || competition.competitions_info?.country?.timezones || null"
            :competition_list="false"
            @time-reached="onCountdownComplete"
        />
      </template>
    </div>
    <h2 class="competition-title">{{ competition.name }}</h2>
    <span class="competition-status" :class="getStatusClass(competition.status_id)">{{ competition.status?.name || $t('competitions.view.not_defined') }}</span>
  </div>
</template>

<script>
import { isOwnerOrganizer} from '@/helpers/roleUtils';
import  CountDown from '@/components/competitions/CountDown.vue';
import {mapState} from "vuex";

export default {
  name: "CompetitionHeader",
  emits: ['register','countdown-complete'],
  props: {
    competition: {
      type: Object,
      required: true
    },
    defaultImage: {
      type: String,
      required: true
    }
  },
  components:{
    CountDown
  },
  computed:{
    ...mapState('user', ['isAuthenticated','user','token']),
  },
  methods:{
    isOwnerOrganizer,
    onCountdownComplete() {
      this.$emit('countdown-complete');
    },
    getStatusClass(statusId) {
      switch (statusId) {
        case 3:
          return 'status-pending';      // Pendiente de aprobación
        case 4:
          return 'status-approved';     // Aprobado
        case 10:
          return 'status-published';    // Publicado
        case 15:
          return 'status-started';      // Empezado
        case 8:
          return 'status-finished';     // Finalizado
        default:
          return 'status-unknown';      // Fallback
      }
    },}
};
</script>

<style scoped>
.competition-header {
  position: relative;
  text-align: center;
}

.competition-image-shell {
  position: relative;
  width: min(80%, calc(min(60vh, 540px) * 16 / 9));
  max-width: 100%;
  aspect-ratio: 16 / 9;
  margin: 0 auto;
  border-radius: 14px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

.competition-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  display: block;
}

@media (max-width: 768px) {
  .competition-image-shell {
    width: 100%;
    max-width: 100%;
    aspect-ratio: 16 / 9;
  }

  .competition-image {
    width: 100%;
    height: 100%;
  }
}

.competition-title {
  font-size: 24px;
  font-weight: bold;
  margin: 15px 0;
}

.competition-status {
  background-color: #f8f9fa;
  padding: 5px 10px;
  border-radius: 5px;
  font-size: 14px;
  margin: 5px 0;
}

.start-button {
  margin: 10px 0 0 0;
  padding: 10px 0 0 0;
}

.register-btn, .registered-btn {
  position: absolute;
  top: 10px;
  right: 10px;
  background-color: #ffc107;
  color: #000;
  border: none;
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 6px;
}

.registered-btn {
  background-color: #28a745;
  color: white;
}
/* Estados con sombra de color sutil */
.status-pending {
  box-shadow: 0 0 10px rgba(255, 165, 0, 0.6); /* naranja claro */
}
.status-approved {
  box-shadow: 0 0 10px rgba(0, 128, 0, 0.6); /* verde */
}
.status-published {
  box-shadow: 0 0 10px rgba(0, 0, 255, 0.6); /* azul */
}
.status-started {
  box-shadow: 0 0 10px rgba(255, 215, 0, 0.6); /* dorado */
}
.status-finished {
  box-shadow: 0 0 10px rgba(128, 128, 128, 0.6); /* gris */
}



</style>
